<script>
import { useAlert } from 'dashboard/composables';
import twitterClient from '../../../../../api/channel/twitterClient';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  data() {
    return { 
      isRequestingAuthorization: false,
      hasLoginStarted: false,
    };
  },
  methods: {
    async requestAuthorization() {
      try {
        this.hasLoginStarted = true;
        this.isRequestingAuthorization = true;
        const response = await twitterClient.generateAuthorization();
        const {
          data: { url },
        } = response;
        window.location.href = url;
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.TWITTER.ERROR_MESSAGE'), {type: 'error'});
      } finally {
        this.isRequestingAuthorization = false;
      }
    },
  },
};
</script>

<template>
  <div class="w-full h-full">
    <!-- PageHeader cho trạng thái ban đầu -->
    <div v-if="!hasLoginStarted" class="w-full">
      <PageHeader 
        :header-title="$t('INBOX_MGMT.ADD.TWITTER.TITLE')" 
        :header-content="$t('INBOX_MGMT.ADD.TWITTER.HELP')" 
      />
      <div class="flex flex-col items-center justify-center h-full text-center mt-12">
        <form @submit.prevent="requestAuthorization">
          <woot-submit-button
            icon="brand-twitter"
            button-text="Sign in with Twitter"
            type="submit"
            :loading="isRequestingAuthorization"
            class="!bg-blue-500 !text-white rounded-lg"
          />
        </form>
      </div>
    </div>

    <!-- Loading state khi đang xử lý -->
    <div v-else class="flex flex-col items-center justify-center h-full text-center">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      <p class="mt-4 text-gray-600">{{ $t('INBOX_MGMT.ADD.TWITTER.PROCESSING') }}</p>
    </div>
  </div>
</template>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>